export default function Eyebrow({ children, tone = 'lead' }) {
  return (
    <span className="inline-flex items-center gap-2 text-[11.5px] font-700 tracking-[0.2em]"
          style={{ color: tone === 'sec' ? 'var(--sec)' : 'var(--lead)' }}>
      <span className="w-6 h-px" style={{ background: tone === 'sec' ? 'var(--sec)' : 'var(--lead)' }}></span>
      {children}
    </span>
  );
}
